import Search from './SearchResults'

export default Search
